import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { TbMenu } from "react-icons/tb";
import logo from '../images/kaizek-logo.svg';
import Footer from './Footer';
import { Helmet } from 'react-helmet';

const TermsOfUse = () => {

    const [onTap, setOnTap] = useState(false);
        
    const [nav, setNav] = useState(false)
    const handleNav = () => {
        setNav(!nav)
        setOnTap((prev) => !prev); 
    }

    const handleScroll = (event, sectionId) => {
        event.preventDefault(); // Prevent default anchor behavior
    
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

    return (
        
        <div className='min-h-screen sm:mt-20 lg:mt-12 xl:mt-8 2xl:mt-12'>
            <Helmet>
                <title>Terms of Use | Kaizek</title>
                <meta name="Kaizek" content="Specializing in custom firmware, embedded software development, and IoT solutions." />
            </Helmet>
            
            <nav className='flex-wrap sm:fixed w-full top-0 left-0 z-50 mx-auto lg:my-2'>
                <div className='px-6 lg:mx-14 lg:px-8 2xl:px-12 py-8 lg:py-4 2xl:py-6 lg:rounded-3xl flex items-center justify-between bg-white/60 backdrop-blur-3xl'>
                    <div className='float-start'>
                    <Link to={"/"}><img src={logo} alt="Kaizek-logo"/></Link>
                    </div>
                    
                    <div className='hidden lg:flex justify-center'>
                        <ul className='hidden sm:inline-flex text-xl leading-8'>
                        {/* <Link to='/core-services'> */}
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Services</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Capabilities</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Smart City</li></Link>
                        <Link to={"/"}><li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'>Case Studies</li></Link>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>            
                        </ul>
                    </div>
                    <div className='hidden xl:flex'>
            
                        <button className="button-theme">
                        Start a project
                        </button>
                    
                    </div>

                    <div onClick={handleNav} className='lg:hidden z-20'>
                    <TbMenu size={20} color={onTap ? '#342E6D' : '#342E6D'} />
                    </div>
                    <div
                    onClick={handleNav}
                    className={nav ? 'overflow-y-hidden z-10 lg:hidden ease-in duration-300 absolute text-[var(--kaizenblue)] left-0 top-0 w-full h-screen bg-[#F7F7F7] px-4 py-8 flex flex-col' : 'absolute top-0 h-screen left-[-100%] ease-in duration-500'}>

                    <div className='place-content-center flex'>
                    <img src={logo} alt="Kaizek logo"/>
                    </div>

                    <ul className='h-max w-full text-center py-8'>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Services</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Capabilities</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Smart City</li></Link>
                        <Link to={"/"}><li className='font-symbol px-4 text-2xl py-4'>Case Studies</li></Link>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>
                    </ul>
                    <div className='place-content-center grid grid-flow-row gap-2 place-items-center my-2'>
                        
                            <button className="button-theme">
                            Start a project
                            </button>
                        
                    </div>
                    </div>
                </div>
            </nav>

            <div>
                <div className='flex flex-col items-center mx-4 sm:mx-auto py-12 lg:py-16 xl:py-28 rounded-xl lg:rounded-3xl bg-white '>
                    <h1 className='text-[var(--kaizekblue)] font-uiBold text-4xl xl:text-5xl text-center'>Terms Of Use</h1>
                    
                    <div className='my-8'>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>1. Form Submissions and Communications</h2>
                            <p>By submitting inquiries through our website forms, you:</p>
                            <ul>
                                <li>Confirm all provided information is accurate</li>
                                <li>Agree to receive communications related to your inquiry</li>
                                <li>Acknowledge that submissions don't create binding agreements</li>
                                <li>Accept that project details may be used for proposal preparation</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>2. Project Information</h2>
                            <p>When submitting project details, you:</p>
                            <ul>
                                <li>Grant us permission to evaluate your requirements</li>
                                <li>Understand that budget ranges are for estimation purposes</li>
                                <li>Agree that timeframes are subject to final project scope</li>
                                <li>Accept that service recommendations may vary based on assessment</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>3. Service Engagement</h2>
                            <p>Our service engagement process includes:</p>
                            <ul>
                                <li>Initial assessment of submitted requirements</li>
                                <li>Project scope definition</li>
                                <li>Resource allocation planning</li>
                                <li>Timeline and budget finalization</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>4. Intellectual Property</h2>
                            <h3 className=' my-2'>4.1 Your Content</h3>
                            <ul>
                                <li>You retain rights to information you submit</li>
                                <li>Grant us license to use for service delivery</li>
                                <li>Allow use for internal business purposes</li>
                            </ul>

                            <h3 className=' my-2'>4.2 Our Content</h3>
                            <p>We retain all rights to:</p>
                            <ul>
                                <li>Website content and design</li>
                                <li>Service descriptions and methodologies</li>
                                <li>Proprietary tools and processes</li>
                                <li>Marketing materials</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>5. Confidentiality</h2>
                            <p>We protect your information through:</p>
                            <ul>
                                <li>Strict confidentiality protocols</li>
                                <li>Secure data storage</li>
                                <li>Limited access controls</li>
                                <li>Non-disclosure agreements</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>6. Service Limitations</h2>
                            <p>Our services are:</p>
                            <ul>
                                <li>Subject to resource availability</li>
                                <li>Based on accurate project information</li>
                                <li>Dependent on mutual cooperation</li>
                                <li>Governed by separate service agreements</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>7. Geographic Scope</h2>
                            <p>With locations in:</p>
                            <ul>
                                <li>Ahmedabad, Mumbai (India)</li>
                                <li>USA</li>
                            </ul>
                            <p>We provide services globally while complying with local laws.</p>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>8. Changes to Terms</h2>
                            <p>We may update these terms:</p>
                            <ul>
                                <li>With notice on our website</li>
                                <li>Through email notifications</li>
                                <li>Maintaining previous versions</li>
                                <li>Preserving user rights</li>
                            </ul>
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>9. Contact Information</h2>
                            <p>For terms-related inquiries:</p>
                            <p>Email: info@kaizek.com</p>
                            {/* <p>Phone: +1 (555) 123-4567 (USA)</p> */}
                        </section>

                        <section className='text-[var(--darkgray)] font-symbol text-base'>
                            <h2 className='font-bold my-2'>10. Governing Law</h2>
                            <p className='sm:hidden'>These terms are governed by applicable laws in our operating jurisdictions, with specific provisions for:</p>
                            <p className='hidden sm:flex'>These terms are governed by applicable laws in our operating jurisdictions, <br/> with specific provisions for:</p>
                            <ul>
                                <li>India</li>
                                <li>United States</li>
                                <li>European Union</li>
                            </ul>
                        </section>

                    </div>

                </div>
            </div>

            <section id='contact'>
                <Footer/>
            </section>
        </div>
        
    )
}

export default TermsOfUse